import React from "react";
import "../styles/MarketingLanding.css";
import Image from "../components/image/Image";

const MarketingLanding = () => {
  return (
    <section className="max-w-7xl mx-auto px-6 py-16">
      {/* Section Heading */}
      <div className="text-center mb-12">
        <h2 className="text-4xl lg:text-5xl font-bold text-black-900 mb-6">
          <span className="underline decoration-blue-500">Smart Solutions</span>{" "}
          for Smarter Businesses
        </h2>
      </div>

      {/* Hero Block */}
      <div className="flex flex-col-reverse lg:flex-row items-center gap-12 mb-12">
        <div className="lg:w-1/2 flex justify-center">
          <div>
            <h2 className="text-3xl lg:text-2xl mb-6 font-bold text-black-900">
              The One-stop Solution for All Your Online Marketing Needs
            </h2>
            <Image
              src="/girl.png"
              alt="Illustration of woman with laptop"
              className="w-full max-w-md object-contain"
              title="Illustration of woman with laptop"
            />
          </div>
        </div>

        <div className="lg:w-1/2">
          <p className="text-black-700 text-lg leading-relaxed">
            We empower businesses with innovative technology driven by
            AI-powered solutions. We specialize in Software Development, IT
            Consulting, Custom Technology Solutions, and Digital Marketing —
            including SEO, PPC, and social media marketing. Our expert team
            delivers scalable, high-impact solutions that drive growth,
            efficiency, and success across startups and enterprises.
          </p>
        </div>
      </div>

      {/* Second Block */}
      <div className="flex flex-col lg:flex-row items-center gap-12">
        <div className="lg:w-1/2 space-y-6">
          <h2 className="text-2xl lg:text-4xl font-bold text-black-900">
            Blending Innovations with{" "}
            <span className="underline decoration-blue-500">
              Strategic Excellence
            </span>
          </h2>
          <p className="text-black-700 text-lg leading-relaxed">
            We transform brands with smarter digital marketing, combining
            innovative design, data-driven insights, and drive meaningful growth
            through targeted strategies and seamless user experiences.
          </p>
        </div>

        <div className="lg:w-1/2 flex justify-center">
          <Image
            src="arrow.png"
            alt="Target and trophy illustration"
            className="w-full max-w-sm object-contain"
          />
        </div>
      </div>
    </section>
  );
};

export default MarketingLanding;
